import { lazy, Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { isSupabaseConfigured } from '@/lib/env'
import { SetupScreen } from '@/features/auth/setup-screen'
import { ProtectedRoute } from '@/features/auth/protected-route'
import { AppLayout } from '@/layout/app-layout'
import { PageLoader } from '@/components/common/states'

// Páginas de auth: leves e no caminho crítico → carregamento imediato.
import { LoginPage } from '@/features/auth/login-page'
import { ResetRequestPage } from '@/features/auth/reset-request-page'
import { ResetPasswordPage } from '@/features/auth/reset-password-page'
import { InvitePage } from '@/features/auth/invite-page'

// Páginas internas: code-splitting por rota (reduz o bundle inicial).
const HojePage = lazy(() =>
  import('@/features/hoje/hoje-page').then((m) => ({ default: m.HojePage })),
)
const KpiPage = lazy(() => import('@/features/kpi/kpi-page').then((m) => ({ default: m.KpiPage })))
const PendenciasPage = lazy(() =>
  import('@/features/pendencias/pendencias-page').then((m) => ({ default: m.PendenciasPage })),
)
const KanbanPage = lazy(() =>
  import('@/features/kanban/kanban-page').then((m) => ({ default: m.KanbanPage })),
)
const RoadmapPage = lazy(() =>
  import('@/features/roadmap/roadmap-page').then((m) => ({ default: m.RoadmapPage })),
)
const WeekPage = lazy(() =>
  import('@/features/week/week-page').then((m) => ({ default: m.WeekPage })),
)
const MuralPage = lazy(() =>
  import('@/features/mural/mural-page').then((m) => ({ default: m.MuralPage })),
)
const TasksListPage = lazy(() =>
  import('@/features/tasks/tasks-list-page').then((m) => ({ default: m.TasksListPage })),
)
const CalendarPage = lazy(() =>
  import('@/features/calendar/calendar-page').then((m) => ({ default: m.CalendarPage })),
)
const ApprovalsPage = lazy(() =>
  import('@/features/approvals/approvals-page').then((m) => ({ default: m.ApprovalsPage })),
)
const CampaignsPage = lazy(() =>
  import('@/features/campaigns/campaigns-page').then((m) => ({ default: m.CampaignsPage })),
)
const EventsPage = lazy(() =>
  import('@/features/events/events-page').then((m) => ({ default: m.EventsPage })),
)
const TemplatesPage = lazy(() =>
  import('@/features/templates/templates-page').then((m) => ({ default: m.TemplatesPage })),
)
const RoutinePage = lazy(() =>
  import('@/features/routines/routine-page').then((m) => ({ default: m.RoutinePage })),
)
const CapacityPage = lazy(() =>
  import('@/features/capacity/capacity-page').then((m) => ({ default: m.CapacityPage })),
)
const TeamPage = lazy(() =>
  import('@/features/settings/team-page').then((m) => ({ default: m.TeamPage })),
)
const ProfilePage = lazy(() =>
  import('@/features/settings/profile-page').then((m) => ({ default: m.ProfilePage })),
)

export default function App() {
  if (!isSupabaseConfigured) return <SetupScreen />

  return (
    <Suspense
      fallback={
        <div className="grid min-h-full place-items-center">
          <PageLoader />
        </div>
      }
    >
      <Routes>
        {/* Rotas públicas de autenticação */}
        <Route path="/entrar" element={<LoginPage />} />
        <Route path="/recuperar-senha" element={<ResetRequestPage />} />
        <Route path="/redefinir-senha" element={<ResetPasswordPage />} />
        <Route path="/convite" element={<InvitePage />} />

        {/* Rotas protegidas */}
        <Route
          element={
            <ProtectedRoute>
              <AppLayout />
            </ProtectedRoute>
          }
        >
          <Route path="/" element={<HojePage />} />
          <Route path="/indicadores" element={<KpiPage />} />
          <Route path="/pendencias" element={<PendenciasPage />} />
          <Route path="/kanban" element={<KanbanPage />} />
          <Route path="/roadmap" element={<RoadmapPage />} />
          <Route path="/semana" element={<WeekPage />} />
          <Route path="/mural" element={<MuralPage />} />
          <Route path="/tarefas" element={<TasksListPage />} />
          <Route path="/calendario" element={<CalendarPage />} />
          <Route path="/aprovacoes" element={<ApprovalsPage />} />
          <Route path="/campanhas" element={<CampaignsPage />} />
          <Route path="/eventos" element={<EventsPage />} />
          <Route path="/templates" element={<TemplatesPage />} />
          <Route path="/rotina" element={<RoutinePage />} />
          <Route path="/capacidade" element={<CapacityPage />} />
          <Route path="/equipe" element={<TeamPage />} />
          <Route path="/perfil" element={<ProfilePage />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  )
}
